import { render, staticRenderFns } from "./DefaultBtn.vue?vue&type=template&id=c785468a&scoped=true&"
import script from "./DefaultBtn.vue?vue&type=script&lang=js&"
export * from "./DefaultBtn.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBtn.vue?vue&type=style&index=0&id=c785468a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c785468a",
  null
  
)

export default component.exports